<template>
  <Head :title="`${user.name}`" />

  <BreezeAuthenticatedLayout>
    <main class="container">
      <div class="main mypage">

        <div class="c-header">
          <Link href="#" onclick="window.history.back(); return false;" class="c-header__back">
            <img src="/images/icons/icon-chevron-left.svg" alt="back">
          </Link>
          <h2 class="c-header--h2">{{ user.name }}</h2>
        </div>

        <div class="mt-24" v-if="auth.user && auth.user.id == user.id">
          <Link :href="`/users/edit`" class="c-button">プロフィールを編集</Link>
        </div>

        <div class="admin-area" v-if="auth.user && auth.user.role == ('admin' || 'owner')">
          <h3 class="admin-area_heading c-heading-h4">管理者エリア</h3>
          <div class="c-button-wrap">
            <Link :href="`/users/analytics`" class="c-button indigo">ユーザー計測</Link>
            <Link :href="`/cohorts`" class="c-button indigo">コホート分析</Link>
            <Link :href="`/users`" class="c-button indigo">登録ユーザー一覧</Link>
          </div>
        </div>

        <div class="admin-area" v-if="auth.user && auth.user.role == 'admin'">
          <h3 class="admin-area_heading c-heading-h4">アプリ管理者</h3>
          <div class="c-button-wrap">
            <Link :href="`/users/owners`" class="c-button green">ジム＋オーナー</Link>
          </div>
        </div>

        <div class="mt-24">
          <Link :href="route('logout')" method="post" as="button" class="c-button gray">ログアウト</Link>
        </div>

      </div>
      <Side />
    </main>
  </BreezeAuthenticatedLayout>
  <footer class="footer">
    <ul class="footer_link">
      <li class="footer_link_item"><Link href="/terms/">利用規約</Link></li>
      <li class="footer_link_item"><Link href="/privacy/">プライバシーポリシー</Link></li>
      <li class="footer_link_item"><a href="https://caracal.jp/" target="_blank">運営会社</a></li>
    </ul>
    <div class="footer_copyright">
      © ロード・オブ・ザ・ウォール
    </div>
    <div class="spacer"></div>
  </footer>
</template>

<script>
  import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
  import { Head, Link, useForm } from '@inertiajs/inertia-vue3';
  import { Inertia } from '@inertiajs/inertia';
  import Side from '@/Shared/Side'

  export default {
    components: {
      BreezeAuthenticatedLayout,
      Head,
      Link,
      Inertia,
      Side,
    },

    props: {
      user: Object,
      auth: Object
    },
  }
</script>
